import { render, staticRenderFns } from "./SAASTab.vue?vue&type=template&id=09d6c84e"
import script from "./SAASTab.vue?vue&type=script&lang=js"
export * from "./SAASTab.vue?vue&type=script&lang=js"
import style0 from "./SAASTab.vue?vue&type=style&index=0&id=09d6c84e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports